<template>
  <q-expansion-item
    expand-separator
    icon="store"
    class="border rounded"
    :label="$t('Connect your store')"
    :caption="$t('You can also connect to different eCommerce websites.')"
  >
    <q-card>
      <q-card-section>
        <source-integration @submit="handleSubmit" />
      </q-card-section>
    </q-card>
  </q-expansion-item>
</template>

<script>
import SourceIntegration from '../integration-wizard/SourceIntegration.vue'

export default {
  name: 'SourceTile',
  emits: ['submit'],
  components: {
    SourceIntegration
  },
  methods: {
    handleSubmit (item) {
      this.$emit('submit', item)
    }
  }
}
</script>
